import ApiService from "@/common/api.service";

const ApiEditcap = {
    newasrange(params){
        return ApiService.post("edit/newfromrange", params)
    }
}

export default ApiEditcap